import { LngLat } from "mapbox-gl";
import { computed } from "mobx";
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from "react-router-dom";
import { useLeaseCompStore } from '../..';
import useCircleWithRadius from '../../hooks/useCircleWithRadius';
import useCircleWithRadiusOnMap from "../../hooks/useCircleWithRadiusOnMap";
import useLeaseCompsWithFocusArea from "../../hooks/useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "../../hooks/useLeaseCompsWithGlobalFilters";
import useProperty from "../../hooks/useProperty";
import { GeoCoordinate } from "../../interfaces/GeoCoordinate";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { formatNumber } from '../../utils/utils';
import LeaseCompsGrid from "../leaseComps/LeaseCompsGrid";
import RadiusDropdown from "../RadiusDropdown";

function PropertyDetailsLeaseCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { longitude, latitude } = useParams();
    const leaseCompStore = useLeaseCompStore();
    const coordinates = useMemo(() => new LngLat(Number(longitude), Number(latitude)), [longitude, latitude]);
    const geoCoordinates = useMemo(() => new GeoCoordinate(coordinates.lat, coordinates.lng), [coordinates]);
    const property = useProperty(coordinates).property!;
    const [radius, setRadius] = useState(5);
    const circle = useCircleWithRadius(property.centerPoint, radius)!;
    useCircleWithRadiusOnMap(geoCoordinates, radius, visible, "PropertyDetailsLeaseCompsTab");
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(
        useMemo(() => computed(() => leaseCompStore.leaseComps.filter(lc => circle.isPointInside(lc.centerPoint))), [circle]).get()
    ));

    useEffect(() => setEntityCount(leaseComps.length), [leaseComps]);

    if (!visible)
        return null;

    return (
        <LeaseCompsGrid
            leaseComps={leaseComps}
            additionalHeaders={[{
                titleStrings: ["DISTANCE"],
                getValue: item => circle!.getDistanceFromCenter(item.centerPoint),
                getLabel: item => {
                    const distance = circle!.getDistanceFromCenter(item.centerPoint);
                    return distance ? formatNumber(distance) : "";
                }
            }]}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(PropertyDetailsLeaseCompsTab);